/**
 * @generated SignedSource<<f96631b1596a6668491310b5e99368fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type layoutEditor_AtlassianHubHome$data = {
  readonly helpCenterById: {
    readonly __typename: "HelpCenter";
    readonly currentPage: ReadonlyArray<{
      readonly id: string;
      readonly pageLayout: {
        readonly layoutAdf: {
          readonly content: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly content: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined>;
    readonly slug: string | null | undefined;
    readonly type: HelpCenterType | null | undefined;
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "layoutEditor_AtlassianHubHome";
};
export type layoutEditor_AtlassianHubHome$key = {
  readonly " $data"?: layoutEditor_AtlassianHubHome$data;
  readonly " $fragmentSpreads": FragmentRefs<"layoutEditor_AtlassianHubHome">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hubAri"
    },
    {
      "kind": "RootArgument",
      "name": "pageAri"
    }
  ],
  "kind": "Fragment",
  "name": "layoutEditor_AtlassianHubHome",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "helpCenterAri",
          "variableName": "hubAri"
        }
      ],
      "kind": "LinkedField",
      "name": "helpCenterById",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "slug"
            },
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": "currentPage",
                "args": [
                  {
                    "fields": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "ids.0",
                            "variableName": "pageAri"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "ids"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "HelpCenterPage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "concreteType": "HelpCenterPageLayout",
                    "kind": "LinkedField",
                    "name": "pageLayout",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLayoutAdf",
                        "kind": "LinkedField",
                        "name": "layoutAdf",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterLayoutAdfContentConnection",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdfContentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterLayoutAdfContent",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "content"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "helpCenterById.currentPage"
            }
          ],
          "type": "HelpCenter"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ],
          "type": "QueryError"
        }
      ]
    }
  ],
  "type": "HelpCenterQueryApi"
};

(node as any).hash = "de208b817737cf4e2a871083a86f6fe0";

export default node;
